import { Component } from "@angular/core";
import { TableModule } from 'primeng/table';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { NgIf } from "@angular/common";

import { DocumentService } from './documents.service';
import { DocumentItem } from './documents.interface'

@Component({
    standalone: true,
    imports: [
        TableModule, 
        InputIconModule,
        IconFieldModule,
        InputTextModule,
        TagModule,
        DropdownModule,
        FormsModule,
        NgIf,
        DialogModule,
        ButtonModule
    ],
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
    providers: [DatePipe]
})
export class DocumentsComponent {

    documents : DocumentItem[] = [];
    documentTypes : string[] = [];
    datasetCount : number = 0;
    documentTypeSelected: string = '';
    globalSearchSelected: number = 0;

    first : number = 0;
    rows : number = 20;

    // modal properties
    modalVisible : boolean = false;
    userIdToDisplay : string = '';
    documentTypeToDisplay : string = '';
    imageToDisplay : string = '';

    private typingTimeout: any;

    constructor(
        private documentService: DocumentService,
        private datePipe: DatePipe
    ) {} 

    // dummy data for testing
    // documentTypes = ['Thai ID', 'Passport', 'Bank Book']
    // documents = [
    //     { created_at : 'Jan 01, 2025 8:00 AM', updated_at : 'Jan 01, 2025 8:00 AM', user_id : '1345', user_email : 'bob@enstack.com', document_name : 'Thai ID', id : 1, document_url : 'www.sample.com' },
    //     { created_at : 'Jan 01, 2025 8:00 AM', updated_at : 'Jan 01, 2025 8:00 AM', user_id : '1533', user_email : 'ross@enstack.com', document_name : 'Thai ID', id : 2, document_url : 'www.sample.com' },
    //     { created_at : 'Jan 01, 2025 8:00 AM', updated_at : 'Jan 01, 2025 8:00 AM', user_id : '1677', user_email : 'kim@enstack.com', document_name : 'Thai ID', id : 3, document_url : 'www.sample.com' },
    //     { created_at : 'Jan 01, 2025 8:00 AM', updated_at : 'Jan 01, 2025 8:00 AM', user_id : '1345', user_email : 'bob@enstack.com', document_name : 'Passport', id : 4, document_url : 'www.sample.com' },
    //     { created_at : 'Jan 01, 2025 8:00 AM', updated_at : 'Jan 01, 2025 8:00 AM', user_id : '1677', user_email : 'kim@enstack.com', document_name : 'Passport', id : 5, document_url : 'www.sample.com' },
    //     { created_at : 'Jan 01, 2025 8:00 AM', updated_at : 'Jan 01, 2025 8:00 AM', user_id : '1345', user_email : 'bob@enstack.com', document_name : 'Bank Book', id : 6, document_url : 'www.sample.com' },

    // ];

    ngOnInit() : void {
        this.fetchData();
    }

    fetchData() : void {
        
        this.documentService.getData(this.first, this.rows, this.globalSearchSelected, this.documentTypeSelected).subscribe({
            next: (data) => {
                this.extractTypesAndData(data);
            },
            error: (err) => {
                console.error('Failed to fetch documents:', err);
            }
        })
    }

    onPageEvent(event: any){
        this.first = event.first;
        this.rows = event.rows;

        this.fetchData()
    }

    onFilter(event:any) {

        if (!event.filters.global) {
            this.globalSearchSelected = 0;
            this.fetchData();
            return
        }

        if (this.globalSearchSelected == event.filters.global.value)
        {
            return
        }

        this.globalSearchSelected = event.filters.global.value;

        clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            this.fetchData();
        }, 300)
    }

    formatDate(dateString: string): string | null {
        return this.datePipe.transform(dateString, 'dd-MMM-yyyy hh:mm a');
    }

    openDocument(userId: string, type:string, url: string) {
        // window.open(url, '_blank', 'noopener,noreferrer');
        this.userIdToDisplay = userId;
        this.documentTypeToDisplay = type;
        this.imageToDisplay = url;
        this.modalVisible = true;
    }      

    extractTypesAndData(data: any) {
        let documents : DocumentItem[] = [];
        // let documentTypes : string[] = [];  Use this declaration if we want to display all possible document types [more info below..]
        let documentTypes : string[] = ['thai-id', 'Passport', 'bank-book'];
        
        // [EN-12330] Uncomment this if we want to display all possible document types, however for now..
        // .. product management only wants thai-id, passport, and bank-book

        // Get all possible values of id_subtype which is the document_type eg. Thai Passport, National ID etc...
        //
        // documentTypes = Array.from(new Set(
        //     data.data.documents
        //         .map((item: any) => item.extras?.id_subtype)
        //         .filter((type: string | undefined | null): type is string => type != null)
        // ));
        // // documentTypes = Array.from(new Set(documentTypes));
        this.documentTypes = documentTypes;

        data.data.documents.forEach((document: any) => {
            // [EN-12330] 
            // Have to do this since thai-id and bank-book exists in docume
            let actualDocumentType : string = '';
            if (documentTypes.includes(document.document_name)) {
                actualDocumentType = document.document_name;
            } else if (documentTypes.includes(document.extras?.id_subtype)) {
                actualDocumentType = document.extras?.id_subtype;
            }

            documents.push({
                created_at : document.created_at,
                updated_at : document.updated_at,
                user_id : document.merchant_id,
                user_email : '',
                document_name : actualDocumentType,
                id : document.id,
                document_url : document.document_url
            })
        });

        this.documents = documents;
        this.datasetCount = data.data.count;
        return [documents, documentTypes];
    }
}

